export default {
  applies_to_articles: 'Si applica ai seguenti articoli',
};
